import { useNotify, downloadCSV, useLogout } from "react-admin";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import { restClient } from "../transport-layer/src";

export const ReportDownloadButton = (props) => {
  const notify = useNotify();
  const logout = useLogout();
  const getlink = () =>
    restClient.getCSV(props.resource, {
      sort: { order: "asc", field: "aggregate_range" },
      range: { start: 0, end: 1000000 },
      filter: props.filter ? props.filter : {},
    })
      .then((e) => {
        downloadCSV(e.data, props.resource);
        notify("Download completed", { type: "info" });
      })
      .catch((e) => {
        if (e.status === 401) {
          logout();
          notify("Your Session has expired", { type: "warning" });
        } else {
          notify("An Error Occured", { type: "error" });
        }
      });

  return (
    <Button
      variant="outlined"
      color="primary"
      sx={{
        // display: "inline-block",
        float: "right",
        // margin: theme.spacing(1),
      }}
      endIcon={<SaveIcon />}
      onClick={getlink}
    >
      {props.label}
    </Button>
  );
};
